(function(){
    angular
        .module('maApp.validation')
        .directive('pbDateAfterOrEqualTo', pbDateAfterOrEqualTo);

    pbDateAfterOrEqualTo.$inject = ['DateCompareValidator'];

    function pbDateAfterOrEqualTo(DateCompareValidator){
        return {
            require: 'ngModel',
            'link': link
        };

        function link(scope, elm, attrs, ctrl) {

            ctrl.$validators.pbDateAfterOrEqualTo = DateCompareValidator.create(scope, attrs, 'pbDateAfterOrEqualTo', compareAfterOrEqualTo);

            function compareAfterOrEqualTo(modelDate, compareDate){
                return modelDate.isAfter(compareDate) || modelDate.is(compareDate);
            }

        }
    }
})();